import $ from 'jquery';
import { $window, MIN_DELAY } from '../variables/variables.js';
import { debounce } from '../functions/functions.js';


// Переключение вкладок
$( () => {
	const $tabs = $( '.projects__tab' );

	if ( ! $tabs.length ) {
		return;
	}

	const $units = $( '.projects__unit' );
	const $box   = $units.parent();

	function setBoxHeight() {
		$box.removeAttr( 'style' );
		setTimeout( () => {
			$box.css( 'min-height', $box.height() );
		}, MIN_DELAY );
	}
	setBoxHeight();
	$window.on( 'resizeWidth', debounce( setBoxHeight ) );

	// Сменить вкладу при клике
	$tabs.on( 'click', function() {
		const $tab   = $( this );
		const STATUS = $tab.attr( 'data-status' );

		if ( $tab.hasClass( 'projects__tab_active' ) ) {
			return;
		}
		$tabs.removeClass( 'projects__tab_active' );
		$tab.addClass( 'projects__tab_active' );
		$units.removeClass( 'projects__unit_active projects__unit_animate' );

		let $thisUnits = $units;

		if ( '0' !== STATUS ) {
			$thisUnits = $thisUnits.filter( `[class*=${STATUS}]` );
		}

		setTimeout( () => {
			$thisUnits.addClass( 'projects__unit_active' );
			setBoxHeight();

			setTimeout( () => {
				$thisUnits.addClass( 'projects__unit_animate' );
			}, MIN_DELAY );
		}, MIN_DELAY );
	} );

	// Удалить пустые вкладки
	$tabs.each( i => {
		const $tab = $tabs.eq( i );
		
		if ( i && ! $units.filter( '[class*=' + $tab.attr( 'data-status' ) + ']' ).length ) {
			$tab.remove();
		}
	} );

	if ( 2 === $( '.projects__tab' ).length ) {
		$tabs.remove();
	}
} );
